import { render, staticRenderFns } from "./IcRanking.vue?vue&type=template&id=5df23200&scoped=true"
import script from "./IcRanking.vue?vue&type=script&lang=js"
export * from "./IcRanking.vue?vue&type=script&lang=js"
import style0 from "./IcRanking.vue?vue&type=style&index=0&id=5df23200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df23200",
  null
  
)

export default component.exports